export default "__VITE_ASSET__DojuiO8H__"